export default "__VITE_ASSET__B0KSQl8Z__"